import { render } from "./CustomerDeleteModal.vue?vue&type=template&id=53744450&scoped=true"
import script from "./CustomerDeleteModal.vue?vue&type=script&lang=js"
export * from "./CustomerDeleteModal.vue?vue&type=script&lang=js"

import "./CustomerDeleteModal.vue?vue&type=style&index=0&id=53744450&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53744450"]])

export default __exports__